import { render, staticRenderFns } from "./RiskSurvey.vue?vue&type=template&id=6359a2f7&"
import script from "./RiskSurvey.vue?vue&type=script&lang=js&"
export * from "./RiskSurvey.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurvey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports